import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LottieLoader from 'Components/LottieLoader';
import BlockUI from 'react-block-ui';
import Icon from 'Components/Icon';
import InfiniteLoader from 'Components/InfiniteLoader';
import { classnames } from 'Utils/classnames';

import { EVENT_MATCH_STATUS_TYPES } from 'Store/constants/sportTypes';
import { resetSystemCoupons, getEventStatusUpdate } from 'Store/actions';
import CouponRowDetails from 'Components/Rows/CouponRow/detail';
import EnvironmentManager from 'Utils/environmentManager';
import ScoreCell from 'Components/Rows/CouponRow/ScoreCell';

import {
  FOOTBALL,
  BASKETBALL,
  WON,
  LOST,
  VOLLEYBALL,
  TENNIS,
  ICE_HOCKEY
} from 'Store/constants/sportTypes';

const COMBINATION_PAGE_SIZE = 10;

class SystemCoupons extends Component {

  constructor (props) {
    super(props);
    this.winningLosingTimer = null;
    this.state = {
      visibleCount: COMBINATION_PAGE_SIZE,
      isPagingSupported: true
    };
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.systemCoupons.data !== this.props.systemCoupons.data
      && prevState.visibleCount !== COMBINATION_PAGE_SIZE) {
      this.setState({ visibleCount: COMBINATION_PAGE_SIZE });
    }
  }

  componentWillUnmount () {
    clearInterval(this.winningLosingTimer);
    this.props.resetSystemCoupons();
  }

  showMoreCombinations = () => {
    this.setState(({ visibleCount }) => ({
      visibleCount: visibleCount + COMBINATION_PAGE_SIZE
    }));
  };

  _renderScoreArea = ({ score, event }) => {
    const { eventScores } = this.props;

    if (!score && eventScores.isLoading) {
      return <div className="coupon-row__score-indicator">
        <LottieLoader type="loading" loop={ true } autoplay width="20px" />
      </div>;
    }

    return score && !EVENT_MATCH_STATUS_TYPES.FIXTURE.includes(score.matchStatus) ? (
      <ScoreCell eventScore={ score } loading={ eventScores.isLoading } event={ event } />
    ) : <div className="coupon-row__market-date">{ event?.eventDateString }</div>;
  };

  _renderNotPlayedSystemCoupons = systemCoupon => {
    return (
      <div className="system-coupon-row__footer--not-played">
        <div className="icon-holder"><Icon iconName="svgWarningWhite" /></div>
        <div className="text-holder"><b>{ systemCoupon.closedCombinationEvents[0] }</b> maçı ve <b>{ systemCoupon.closedCombinationEvents[1] }</b> maçı birbirleriyle kombinlenemez. </div>
      </div>
    );

  };

  requestWinninLosing (eventList) {
    this.props.getEventStatusUpdate(eventList);
  }

  componentDidMount () {
    const { systemCoupons: { data = [] } } = this.props;

    if (typeof window !== 'undefined' && !window.IntersectionObserver) {
      this.setState({ isPagingSupported: false });
    }

    const isWinLoseApiEnabled = EnvironmentManager.getMessageText({ key: 'winning_losing_request_enable' });

    let eventList = [];
    data?.map(systemCoupon => {
      systemCoupon?.bets?.map(event => {
        if (![WON, LOST].includes(event.winningStatus)
        && [FOOTBALL, BASKETBALL, VOLLEYBALL, TENNIS, ICE_HOCKEY].includes(event.sportType)
        && event.eventDate <= new Date().getTime()
        && isWinLoseApiEnabled === 'true'
        ) {
          eventList.push(event);
        }
      });
    });


    if ( eventList.length && eventList.length > 0) {
      const requestDuration = EnvironmentManager.getMessageText({ key: 'winning_losing_request_duration' });
      clearInterval(this.winningLosingTimer);
      this.winningLosingTimer = setInterval(() => {
        this.requestWinninLosing(eventList);
      }, requestDuration);
    }
  }

  render () {
    const { systemCoupons: { data = [], isLoading }, coupons, eventScores } = this.props;
    const { visibleCount, isPagingSupported } = this.state;
    const eventStatusMap = new Map(
      (coupons.eventStatusUpdate?.data || []).map(status => [
        `${status.marketId}:${status.outcomeNo}`,
        status
      ])
    );

    const visibleCoupons = isPagingSupported ? data.slice(0, visibleCount) : data;
    const hasMoreCoupons = isPagingSupported && data.length > visibleCount;

    return (
      <div className="system-coupons">
        <BlockUI
          tag="div"
          className="block-ui--relative block-ui--100percent"
          blocking={ isLoading }
          loader={ <LottieLoader type="loading" loop={ true } autoplay width="75px" /> }
          renderChildren={ true }>
          { visibleCoupons.map((systemCoupon, couponIndex) => {

            const systemCouponRowContainerClassName = classnames({
              'system-coupon-row__container': true,
              'system-coupon-row__container--passive': !systemCoupon.isPlayed
            });

            return (
              <div key={ couponIndex } className={ systemCouponRowContainerClassName }>
                {
                  systemCoupon.bets.map((event, eventIndex) => {

                    event = { ...event, isBilyonerTvHidden: true };

                    const eventStatus = eventStatusMap.get(`${event.marketId}:${event.marketOutcomeNo}`);

                    const eventScore = eventScores?.data?.[event.eventId];

                    return (
                      <CouponRowDetails
                        key={ eventIndex }
                        event={ event }
                        score={ eventScore }
                        eventStatus={ eventStatus }
                        systemCoupon
                      >
                        { this._renderScoreArea({
                          score: eventScore,
                          event: event }) }
                      </CouponRowDetails>
                    );
                  })
                }

                <div className="system-coupon-row__footer">
                  <div className="system-coupon-row__footer__info">
                    <span>Toplam Oran:  &nbsp;</span>
                    <span className="system-coupon-row__footer__value">{ systemCoupon.totalOdd }</span>
                  </div>
                  <div className="system-coupon-row__footer__info">
                    <span>Tahmini Kazanç: &nbsp;</span>
                    <span className="system-coupon-row__footer__value">{ systemCoupon.multiExpectedWinAmountText } TL</span>
                  </div>

                </div>
                {
                  !systemCoupon.isPlayed && this._renderNotPlayedSystemCoupons(systemCoupon)
                }

              </div>
            );
          })
          }
          { hasMoreCoupons && (
            <InfiniteLoader
              height="24px"
              isLoading={ true }
              isActive={ hasMoreCoupons }
              onShow={ this.showMoreCombinations }
            />
          ) }
        </BlockUI>
      </div>
    );
  }
}

SystemCoupons.propTypes = {
  coupons: PropTypes.object,
  eventScores: PropTypes.object,
  resetSystemCoupons: PropTypes.func,
  getEventStatusUpdate: PropTypes.func,
  systemCoupons: PropTypes.object
};

const mapStateToProps = state => ({
  coupons: state.coupons,
  eventScores: state.eventScores,
  systemCoupons: state.coupons.systemCoupons
});

export default connect(
  mapStateToProps, { resetSystemCoupons, getEventStatusUpdate }
)(SystemCoupons);
